const COMPENDIUM_FALLBACK_ORIGIN = 'https://venue.platypus360.com';

export const supportsVenueSubdomain = (venueId) =>
  /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test((venueId || '').trim());

export const buildCompendiumUrl = (venueId, path = '/') => {
  const normalizedVenueId = (venueId || '').trim();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const baseOrigin = supportsVenueSubdomain(normalizedVenueId)
    ? `https://${normalizedVenueId}.platypus360.com`
    : COMPENDIUM_FALLBACK_ORIGIN;
  const url = new URL(normalizedPath, `${baseOrigin}/`);

  if (!normalizedVenueId) {
    return url.toString();
  }

  if (!supportsVenueSubdomain(normalizedVenueId)) {
    url.searchParams.set('venue_id', normalizedVenueId);
  }

  return url.toString();
};

export const getCompendiumOrigin = (venueId) => {
  const normalizedVenueId = (venueId || '').trim();
  if (supportsVenueSubdomain(normalizedVenueId)) {
    return `https://${normalizedVenueId}.platypus360.com`;
  }
  return COMPENDIUM_FALLBACK_ORIGIN;
};
